document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".xb-product-quantity");

  if (!targets.length) return;

  const updateQuantityIfHidden = () => {
    targets.forEach((target) => {
      if (!target.classList.contains("show")) {
        target.innerText = "0";
      }
    });
  };

  updateQuantityIfHidden();

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        updateQuantityIfHidden();
      }
    }
  });

  targets.forEach((target) => {
    observer.observe(target, { attributes: true, attributeFilter: ["class"] });
  });
});
